"use client";

import { useAuth } from "@/contexts/AuthContext";
import { useEffect, useRef } from "react";
import { BrandSplitShell } from "@/components/BrandSplitShell";
import { hasStoredAuthCredentials } from "@/utils/api";

export default function LoginLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { loading, checkAuth } = useAuth();
  const restoreFromStorageAttempted = useRef(false);

  // Do not redirect when `user` is set — that races with post-login routes like
  // /login/setup-passkey. Subpages under /login handle "already signed in" themselves.
  useEffect(() => {
    if (loading) return;
    if (
      hasStoredAuthCredentials() &&
      !restoreFromStorageAttempted.current
    ) {
      restoreFromStorageAttempted.current = true;
      void checkAuth();
    }
  }, [loading, checkAuth]);

  return <BrandSplitShell>{children}</BrandSplitShell>;
}
